var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceTypeWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1209_6029)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.51074,
    width: 60,
    height: 60,
    rx: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1209_6029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2916 13.7C48.1256 13.5545 47.8918 13.489 47.6719 13.5171L32.2404 15.5771C31.86 15.628 31.5373 15.9526 31.5373 16.3364V29.8118C31.5373 30.2348 31.9446 30.5691 32.3676 30.5691H47.7602C48.1832 30.5691 48.5801 30.2348 48.5801 29.8118V14.2763C48.58 14.0553 48.4576 13.8455 48.2916 13.7ZM47.048 29.0372H33.0692V17.0066L47.0481 15.1515V29.0372H47.048Z",
    fill: "#4739E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8127 32.3741C29.6687 32.2304 29.5311 32.1332 29.3021 32.1504L14.849 32.1807C14.4264 32.1815 14.1115 32.5244 14.1115 32.9467V44.4365C14.1115 44.8221 14.3714 45.1475 14.7536 45.1965L29.2202 47.04C29.2528 47.0441 29.2782 47.046 29.3104 47.046C29.4955 47.046 29.6402 46.9786 29.7812 46.8549C29.9462 46.7094 30.0053 46.4999 30.0053 46.28V32.9164C30.0053 32.713 29.9567 32.5181 29.8127 32.3741ZM28.4734 45.4105L15.6434 43.7618V33.7112L28.4734 33.6839V45.4105Z",
    fill: "#4739E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7882 32.1518L32.3687 32.1011C32.3683 32.1011 32.3679 32.1011 32.3675 32.1011C32.1645 32.1011 31.9378 32.2105 31.7942 32.3541C31.6502 32.4978 31.5373 32.7217 31.5373 32.9251V46.6631C31.5373 47.0465 31.8529 47.3708 32.233 47.4224L47.6417 49.5041C47.6757 49.5086 47.7182 49.5108 47.7522 49.5108C47.9366 49.5108 48.1467 49.4442 48.2873 49.3216C48.4537 49.1761 48.5801 48.9659 48.5801 48.7449V32.9468C48.58 32.5241 48.2108 32.1525 47.7882 32.1518ZM47.048 47.8682L33.0691 45.9936V33.6922L47.048 33.7116V47.8682Z",
    fill: "#4739E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7775 16.1358C29.6119 15.9903 29.4226 15.9226 29.206 15.9515L14.6205 17.8249C14.2383 17.8739 13.92 18.1992 13.92 18.5845V29.8117C13.92 30.2347 14.3273 30.569 14.7503 30.569H29.3037C29.7267 30.569 30.0053 30.2347 30.0053 29.8117V16.7111C30.0053 16.4908 29.9428 16.2814 29.7775 16.1358ZM28.4734 29.0371H15.452V19.2581L28.4734 17.5822V29.0371Z",
    fill: "#4739E7"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 2.01074,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "#4739E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1209_6029",
    x: 0.25,
    y: 0.510742,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1209_6029"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.878431 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1209_6029"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1209_6029",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1209_6029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(13.25 13.5107)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceTypeWindows);
export default __webpack_public_path__ + "static/media/device-type-windows.4ae4a57fc93ff6253ef13a24f784c8a2.svg";
export { ForwardRef as ReactComponent };